import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { useStoreData } from '../../../hooks';
import { media } from '../../../services/media';
import { parseHTML } from '../../../services/parseHTML';
import { replaceShortcodes } from '../../../services/replaceShortcodes';
import { Content } from '../../Content';
import { OfferContext } from '../context';

export const OfferContent: React.FC = () => {
    const { content, slug } = useContext(OfferContext);

    const { requestID } = useStoreData().user;

    if (!content || !requestID) {
        return null;
    }

    const offerBody = replaceShortcodes(content, { slug, requestID });

    return <StyledContent>{parseHTML(offerBody, 'markdown')}</StyledContent>;
};

const StyledContent = styled(Content)`
    position: relative;

    ${media.max('lg')} {
        padding: 20px 15px;
    }

    ${media.min('lg')} {
        padding: 25px 35px;
    }

    ul,
    ol {
        padding-left: 18px;

        ${media.between('lg', 'xxl')} {
            font-size: 16px;
        }

        ${media.min('xxl')} {
            font-size: 20px;
        }
    }
`;
